import React from "react";
import { FaStar } from "react-icons/fa";
import moment from "moment";

const Review = ({ review }) => {
 if (!review || review.length == 0) {
    return (
      <div className="py-2 text-sm text-center text-gray-500">
        No Reviews Found
      </div>
    );
  }

  const rating = Number(review.overall);

  return (
    <div className="
      relative bg-white border border-gray-200 
      shadow-[0_8px_20px_rgba(0,0,0,0.08)]
      p-4 my-1 overflow-hidden
    ">

      {/* LEFT COLOR BAR */}
      <div className="
        absolute left-0 top-0 w-2 h-full 
        bg-gradient-to-b from-[#FF7B00] via-[#FF2D92] to-[#4B7BFF]
        skew-y-6
      "></div>

      {/* Skew Top Ribbon */}
      <div className="
        absolute -top-3 -right-6 w-32 h-6 
        bg-gradient-to-r from-[#4B7BFF] via-[#FF2D92] to-[#FF7B00]
        skew-x-12 opacity-80
      "></div>

      {/* NAME + STARS */}
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-gray-800">
          {review.fullname}
        </h3>

        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <FaStar
              key={i}
              size={15}
              className={i < rating ? "text-[#FF7B00]" : "text-gray-300"}
            />
          ))}
        </div>
      </div>

      {/* COMMENT */}
      <p className="mt-2 text-sm leading-snug text-gray-600">
        {review.comments}
      </p>

      {/* DATE */}
      <p className="mt-2 text-sm font-semibold text-slate-900">
{moment(review.publish_date).format("DD MMM YYYY")}
      </p>
    </div>
  );
};

export default Review;

